import { Route } from '@angular/router';

import { cricketTacticsOnlineGameRoutes } from '../../online-games/games/cricket-tactics/online-games-cricket-tactics.routes';

export const cricketTacticsGameRoutes: Route[] = [...cricketTacticsOnlineGameRoutes];
